// Initialize accordion states on page load
window.laytheme.on('newpageshown', function() {
	jQuery('.lay-accordion-item').each(function() {
		var $item = jQuery(this);
		var $title = $item.find('.lay-accordion-title');
		var $content = $item.find('.lay-accordion-content');
		var $icon = $item.find('.lay-accordion-icon');
		
		// Set initial state based on content classes
		if ($content.hasClass('open')) {
			$title.addClass('open');
			$icon.find('.lay-accordion-icon-open').show();
			$icon.find('.lay-accordion-icon-closed').hide();
		} else {
			$title.removeClass('open');
			$icon.find('.lay-accordion-icon-open').hide();
			$icon.find('.lay-accordion-icon-closed').show();
		}
	});
});

jQuery(document).on('click', '.lay-accordion-title', function() {
	var $title = jQuery(this);
	var $content = $title.next('.lay-accordion-content');
	var $accordionWrapper = $title.closest('.lay-accordion-wrapper');
	var $icon = $title.find('.lay-accordion-icon');
	if ($accordionWrapper.hasClass('lay-accordion-disable-open-close-on-click')) {
		return;
	}
	
	// Check if this accordion should close others when opening
	if ($accordionWrapper.hasClass('lay-accordion-close-others')) {
		// Close all other accordion items in this accordion
		$accordionWrapper.find('.lay-accordion-item').each(function() {
			var $itemTitle = jQuery(this).find('.lay-accordion-title');
			var $itemContent = jQuery(this).find('.lay-accordion-content');
			var $itemIcon = jQuery(this).find('.lay-accordion-icon');
			
			if ($itemTitle[0] !== $title[0]) {
				$itemTitle.removeClass('open');
				$itemContent.removeClass('open').addClass('closed');
				// Hide open icon, show closed icon
				$itemIcon.find('.lay-accordion-icon-open').hide();
				$itemIcon.find('.lay-accordion-icon-closed').show();
			}
		});
	}
	
	// Toggle the clicked item
	$title.toggleClass('open');
	$content.toggleClass('open closed');
	
	// Toggle icon visibility
	if ($title.hasClass('open')) {
		// Show open icon, hide closed icon
		$icon.find('.lay-accordion-icon-open').show();
		$icon.find('.lay-accordion-icon-closed').hide();
	} else {
		// Hide open icon, show closed icon
		$icon.find('.lay-accordion-icon-open').hide();
		$icon.find('.lay-accordion-icon-closed').show();
	}
});

// Collapse row when clicking content area, except when clicking a link (only if setting is enabled)
jQuery(document).on('click', '.lay-accordion-content', function(e) {
	var $content = jQuery(this);
	var $wrapper = $content.closest('.lay-accordion-wrapper');
	if ($wrapper.hasClass('lay-accordion-disable-open-close-on-click')) {
		return;
	}
	if (!$wrapper.attr('data-collapse-on-content-click')) {
		return;
	}
	// Don't collapse if the click was on a link or inside a link
	if (jQuery(e.target).closest('a').length) {
		return;
	}
	var $item = $content.closest('.lay-accordion-item');
	var $title = $item.find('.lay-accordion-title');
	var $icon = $item.find('.lay-accordion-icon');
	// Only collapse if currently open
	if (!$content.hasClass('open')) {
		return;
	}
	$title.removeClass('open');
	$content.removeClass('open').addClass('closed');
	$icon.find('.lay-accordion-icon-open').hide();
	$icon.find('.lay-accordion-icon-closed').show();
});
